import { makeObservable } from 'mobx';
import { getTenantConfigReq } from '@/api/global';
import { changeName, setThemeSourceImgFromObs } from '@/utils/global';
import { obsDownloadFile } from '@/utils/obsService';
class Global {
    constructor() {
        makeObservable(this);
    }

    //    获取应用名称
    getTenantConfig = async () => {
        let res = await getTenantConfigReq();
        if (res.success) {
            if (res?.data && res.data.content.length) changeName(res.data.content);
        }
    };

    //    获取主题obs图片
    getThemeFromObsImg = async (themeType) => {
        let res = await obsDownloadFile('function-attachment-upload', 'theme/pc/themeSource.json');
        setThemeSourceImgFromObs(res, themeType);
    };
}

export default new Global();
